
/** APP SESSION COOKIE  cookie name  = walls_app_session */
export const setCookie = (name: string, token: string, time: number) => {
     const date = new Date();
     date.setTime(date.getTime() + (time * 60 * 60 * 1000)); // 2 hrs
     const expires = `expires=${date.toUTCString()}`;
     return document.cookie = `${name}=${token};${expires};path=/`;
 }
 
 export const getCookie = (name: string) => {
     name += '=';
     const decodedCookie = decodeURIComponent(document.cookie);
     const cookie = decodedCookie.split(';');
     for (let i = 0; i < cookie.length; i++) {
          let c = cookie[i];
          while (c.charAt(0) === ' ') {
               c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
               return c.substring(name.length, c.length); //return the value of the cookie if exists
          }
     }
     return null;
 }
 
 export const deleteCookie = (name: string, type?:string) => {
     sessionStorage.clear();     
     document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
     if(type === 'microsoft'){
          return window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}/walls`;
     }
     return;
 }